export default __webpack_public_path__ + "static/media/OIG_Logo_Gray.82131be1.png";